import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { ModalController, NavParams } from '@ionic/angular';
import { EnumGenericRoleActionAlerts } from '@pages/BasePage';

export interface IReportExportField {
    key: string;
    label: string;
    type: 'text' | 'select' | 'age';
    value?: any;
    options?: { Id: any, Name: string }[];
    allowAll?: boolean;
    orderDescendingValue?: boolean;
}

export interface IReportExportType {
    Id: number;
    Name: string;
}

@Component({
    selector: 'app-report-export',
    templateUrl: './report-export.component.html',
    styleUrls: ['./report-export.component.scss'],
})
export class ReportExportModalComponent implements OnInit {

    public HeaderTitle: string;

    public ReportTypes: IReportExportType[];

    public Fields: IReportExportField[];

    public Form: FormGroup;

    constructor(private ModalController: ModalController,
        private NavParams: NavParams) {

        this.HeaderTitle = this.NavParams.get('title') || 'Exportar Relatório';
        this.ReportTypes = this.NavParams.get('reportTypes') || [];
        this.Fields = this.NavParams.get('fields') || [];

        const controls: { [key: string]: FormControl } = {
            ReportType: new FormControl(this.ReportTypes[0]?.Id ?? null)
        };

        this.Fields.forEach(field => {
            controls[field.key] = new FormControl(field.value ?? null);

            if (field.type === 'age')
                controls[`${field.key}OrderDescending`] = new FormControl(field.orderDescendingValue ?? true);
        });

        this.Form = new FormGroup(controls);
    }

    ngOnInit() { }

    /**
     *
     * @param field
     */
    public ToggleOrder(field: IReportExportField) {

        const control = this.Form.get(`${field.key}OrderDescending`);

        control.setValue(!control.value);
    }

    /**
     *
     * @param ev
     */
    Close(ev?: any) {

        ev?.preventDefault();
        ev?.stopPropagation();

        this.ModalController.dismiss(null, EnumGenericRoleActionAlerts.Close);
    }

    /**
     *
     * @param ev
     */
    public OnConfirm(ev?: any) {

        ev?.preventDefault();
        ev?.stopPropagation();

        const value = this.Form.value;

        const filters: { [key: string]: any } = {};

        this.Fields.forEach(field => {
            filters[field.key] = value[field.key];

            if (field.type === 'age')
                filters[`${field.key}OrderDescending`] = value[`${field.key}OrderDescending`];
        });

        this.ModalController.dismiss({
            reportTypeId: value.ReportType,
            filters
        }, EnumGenericRoleActionAlerts.Confirm);
    }
}
